/**
 * Build-time: app is deployed under /motor/ on the origin (webpack publicPath + router base).
 * Set VUE_APP_PATH_BASED=true in the env file for the build/serve mode.
 */
export const isAppPathBased = process.env.VUE_APP_PATH_BASED === 'true';
export const routerBasePath = isAppPathBased ? '/motor/' : '/';
